const commaSeparateNumber = (number: number): string => number.toLocaleString();

export default commaSeparateNumber;
